import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import {
  Grid, TextField, Button, Typography,
} from '@material-ui/core';
import RecordPreviewStyles from './styles';
import GreatRecordAction from './feel-record-actions/GreatRecordAction';
import GoodRecordAction from './feel-record-actions/GoodRecordAction';
import PartiallyUsefulRecordAction from './feel-record-actions/PartiallyUsefulRecordAction';
import DeleteRecordAction from './feel-record-actions/DeleteRecordAction';
import DevelopmentComponent from "../../../../DevelopmentComponent";
import {useDispatch, useSelector} from 'react-redux'
import {selectUploadMedia} from "../../../../../store/modules/articles/selectors";
import {StreamMeta} from "../../../record/UploadRecordContext";
import {saveArticleVideoRequest} from "../../../../../store/modules/articles/actions";

type Props = {
  currentVideo: StreamMeta | undefined;
  closeModal: () => void;
}

const FeelRecord = ({currentVideo, closeModal}: Props) => {
  const classes = RecordPreviewStyles();
  const [inputValue, setInputValue] = useState<string>('');
  const inputRef: React.MutableRefObject<HTMLInputElement | null> = useRef(null);
  const {uploads} = useSelector(selectUploadMedia);
  const dispatch = useDispatch();

  const changeInput = useCallback((e) => {
    setInputValue(e.target.value);
    return false;
  }, [setInputValue]);

  const updateVideoHandler = useCallback(()=>{
    if(currentVideo && uploads.length){
      const foundUpload = uploads.find((item)=> item.uploadId === currentVideo.id);
      if(foundUpload){
        if(inputValue){
          dispatch(saveArticleVideoRequest({id: foundUpload.article.ref.video!.id, title: inputValue}))
          currentVideo.name = inputValue;
        }
        closeModal();
      }
    }
  },[uploads, currentVideo, closeModal, inputValue, dispatch]);


  useEffect(()=>{
    const ref = inputRef.current;
    const keyDownHandler = (event: KeyboardEvent) => {
      if(event.key === 'Enter'){
        updateVideoHandler();
      }
    };
    if (ref) {
      ref.addEventListener('keydown', keyDownHandler);
    }
    return () => {
      if (ref) {
        ref.removeEventListener('keydown', keyDownHandler);
      }
    };
  },[inputRef, updateVideoHandler]);

  useEffect(() => {
    const ref = inputRef.current;
    const keyDownHandler = (event: KeyboardEvent) => {
      if (event.key === ' ') {
        event.stopPropagation();
      }
    };

    if (ref) {
      ref.addEventListener('keydown', keyDownHandler);
    }


    return () => {
      if (ref) {
        ref.removeEventListener('keydown', keyDownHandler);
      }
    };
  }, [inputRef]);

  return (
    <Grid container className={classes.feelRecord}>
      <Grid container alignItems="flex-start" className="moodContainer" item sm={6} xs={12}>
        <TextField ref={inputRef} label="Recording Name (optional)" value={inputValue} onChange={changeInput} className={classes.input} />
        <DevelopmentComponent >
          <Grid container spacing={1} alignItems="flex-start" direction="column">
            <Typography variant="h6">How do you feel about this recording?</Typography>
            <GreatRecordAction mood={null} />
            <GoodRecordAction mood={null} />
            <PartiallyUsefulRecordAction mood={null} />
            <DeleteRecordAction mood={null} />
          </Grid>
        </DevelopmentComponent>
      </Grid>
      <Grid container className="buttonContainer" justify="flex-end" alignItems="flex-end" item sm={6} xs={12}>
        <Button onClick={updateVideoHandler} className={classes.button}>Done</Button>
      </Grid>
    </Grid>
  );
};

export default FeelRecord;
